var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'dynamic-fields',
        { 'display--grid': _vm.hasFields }
    ]},[(_vm.hasFields)?_vm._l((_vm.fields),function(key,index){return _c('base-field',{key:index,class:[
                'dynamic-fields__input',
                { 'dynamic-fields__input--padding': index === _vm.fields.length - 1 }
            ],attrs:{"settings":{
                label: { class: 'capitalize', text: _vm.translations[index] ? _vm.$t(("global." + (_vm.translations[index]))) : key },
                input: Object.assign({}, ( !_vm.isEdition && {
                        component: 'InputBasic',
                        name: key,
                        type: 'text',
                        class: 'field__input--default typography--default color--default',
                        browserAutocomplete: key,
                        isRequired: false
                    }),
                    {name: key,
                    value: _vm.obj[key],
                    disableClass: 'dynamic-fields__input__element'}),
                isEdition: _vm.isEdition,
                allowFilling: _vm.allowFilling
            }}})}):(_vm.showEmptyMessage)?_c('div',{staticClass:"dynamic-fields__empty"},[_vm._v(_vm._s(_vm.$t('warning.notAvailable')))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }